<template>
  <h1 style="margin-left: 15px">
    Herzlich Willkommen
  </h1>
</template>

<script>
export default {
  name: "home",
  components: {
  }
};
</script>
<style lang="scss">
#table {
  td {
    padding: 5px;
    vertical-align: top;
  }
  .item {
    text-align: left;
  }
}
</style>
